module.exports = __webpack_public_path__ + "static/media/blog1.159566e6.md";